(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "./title-bar.less", "./mixins/title-bar", "../icon"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("./title-bar.less"), require("./mixins/title-bar"), require("../icon"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.titleBar, global.titleBar, global.icon);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _titleBar, _titleBar2, _icon) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _titleBar2 = _interopRequireDefault(_titleBar2);
  _icon = _interopRequireDefault(_icon);
  var _default = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        staticClass: "nx-popup-title-bar",
        class: [_vm.borderBottom ? '' : 'no-border-bottom', "title-align-" + _vm.titleAlign, "large"].concat({
          'large-radius': _vm.largeRadius
        }),
        on: {
          "touchmove": _vm.$_preventScroll
        }
      }, [!_vm.onlyClose ? [_vm.okText ? _c('div', {
        staticClass: "title-bar-left nx-popup-confirm",
        domProps: {
          "innerHTML": _vm._s(_vm.okText)
        },
        on: {
          "click": function click($event) {
            return _vm.$emit('confirm');
          }
        }
      }) : _vm.$slots.confirm ? _c('div', {
        staticClass: "title-bar-left nx-popup-confirm",
        on: {
          "click": function click($event) {
            return _vm.$emit('confirm');
          }
        }
      }, [_vm._t("confirm")], 2) : _vm._e()] : _vm._e(), _vm.title ? _c('div', {
        staticClass: "title-bar-title"
      }, [_vm.title && !_vm.logo ? _c('p', {
        staticClass: "title",
        attrs: {
          "nx-popup-aria-auto-focus": "true",
          "aria-label": _vm.title
        },
        domProps: {
          "innerHTML": _vm._s(_vm.title)
        }
      }) : _vm._e(), _vm.logo ? _c('img', {
        staticClass: "title logo",
        attrs: {
          "alt": "",
          "src": "https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/4fb2f930-78d1-11ec-9d2b-77bcf0c0ff02.png"
        }
      }) : _vm._e()]) : _c('div', {
        staticClass: "title-bar-title"
      }, [_vm._t("title")], 2), !_vm.onlyClose && _vm.showCloseOrCancel ? [_vm.cancelText ? _c('div', {
        staticClass: "title-bar-right nx-popup-cancel",
        domProps: {
          "innerHTML": _vm._s(_vm.cancelText)
        },
        on: {
          "click": function click($event) {
            return _vm.$emit('cancel');
          }
        }
      }) : _c('div', {
        staticClass: "title-bar-right nx-popup-cancel",
        on: {
          "click": function click($event) {
            return _vm.$emit('cancel');
          }
        }
      }, [_c('img', {
        staticClass: "title-bar-icon",
        attrs: {
          "src": "https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/13937e30-2144-11ee-88e2-1bb1cf1d109f.png",
          "alt": "关闭",
          "role": "button"
        }
      })])] : _vm._e(), _vm.onlyClose && _vm.showCloseOrCancel ? [_c('div', {
        staticClass: "title-bar-right nx-popup-close",
        on: {
          "click": function click($event) {
            return _vm.$emit('cancel');
          }
        }
      }, [_c('img', {
        staticClass: "title-bar-icon",
        attrs: {
          "role": "button",
          "src": "https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/13937e30-2144-11ee-88e2-1bb1cf1d109f.png",
          "alt": "关闭"
        }
      })])] : _vm._e()], 2);
    },
    name: 'nx-popup-title-bar',
    mixins: [_titleBar2.default],
    components: (0, _defineProperty2.default)({}, _icon.default.name, _icon.default),
    props: {},
    watch: {
      largeRadius: {
        handler: function handler(val) {
          this.$parent.largeRadius = val;
        },
        immediate: true
      }
    },
    methods: {
      $_preventScroll: function $_preventScroll(e) {
        /* istanbul ignore next */
        e.preventDefault();
      }
    }
  };
  _exports.default = _default;
});